import { Dispatch, Store } from "redux";
import { TActionRequest } from "../../base/types/redux";
import MiddlewareRegistry from "../../base/redux/MiddlewareRegistry";
import { LoginRequest } from "../utils/types";
import { apiLogin } from "./services";
import { ACTION_TYPES } from "./actionTypes";
import { setLoginState, setUserInfo} from "./actions";
import { message } from 'antd';

export const middleware =
  ({ dispatch, getState }: Store) =>
  (next: Function) =>
  async (action: TActionRequest<any>) => {
    next(action);
    switch (action.type) {
      case ACTION_TYPES.LOGIN: {
        return await handleLogin(dispatch, action, getState);
      }
    }
  };

MiddlewareRegistry.register(middleware);

const handleLogin = async (
  dispatch: Dispatch,
  action: TActionRequest<LoginRequest>,
  getState: () => {  }
) => {
  try {
    const response = await apiLogin(action.params!);
    if (response?.status?.code === "A200") {
      dispatch(setUserInfo(response));
      dispatch(setLoginState({ isFetching: false, isSuccess: true, data: response.data }));
      localStorage.setItem("user_info", JSON.stringify(response?.data));
      localStorage.setItem("access_token", response?.data?.jwt?.access_token); 
    }
  } catch (err: any) {
    message.error(err.response?.data.status.message);
    dispatch(setLoginState({ isFetching: false, isSuccess: false, data: err }));
  }
};